module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-toolbar', {
    staticClass: "main-toolbar"
  }, [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-title"
  }, [_c('md-avatar', {
    staticClass: "md-small"
  }, [(_vm.user.profile_picture) ? _c('img', {
    attrs: {
      "src": _vm.user.profile_picture,
      "alt": "People"
    }
  }) : _c('img', {
    attrs: {
      "src": require('../../assets/img/silhouette.jpg'),
      "alt": "People"
    }
  })]), _vm._v(" "), (_vm.user.username) ? _c('span', {
    staticClass: "avatar-name-role"
  }, [_vm._v(_vm._s(_vm.user.username))]) : _c('span', {
    staticClass: "avatar-name-role"
  }, [_vm._v("Cuelist User")])], 1), _vm._v(" "), (_vm.fromDashboard) ? _c('div', [(_vm.isActivePay) ? _c('span', {
    staticClass: "ql-dashboard-role"
  }, [_vm._v("Collaborator")]) : _c('span', {
    staticClass: "ql-dashboard-role"
  }, [_vm._v("Observer")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dashboard-toggles"
  }, [_c('span', {
    staticClass: "dark-mode-toggle"
  }, [_c('button', {
    staticClass: "ql-theme-toggle",
    attrs: {
      "type": "button",
      "aria-label": _vm.localShowMode ? 'Switch to light mode' : 'Switch to dark mode'
    },
    on: {
      "click": _vm.toggleShowMode
    }
  }, [_c('span', {
    staticClass: "ql-theme-toggle-ico"
  }, [_vm._v(_vm._s(_vm.localShowMode ? '☀' : '☾'))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.localShowMode ? 'Light' : 'Dark'))])])])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex": "1"
    }
  }), _vm._v(" "), (!_vm.connected) ? _c('span', {
    staticClass: "connect-status"
  }, [_vm._v("Offline")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "main-header-logo",
    attrs: {
      "src": require('../../assets/img/cuelist-full.svg'),
      "alt": "cuelisttext"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d8e8330","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/header.vue
// module id = 1228
// module chunks = 21